<template>
	<div v-on:click="closeMenu()">
		<headlink v-if="parent == '0'"></headlink>
		<headlink1 v-if="parent == '1'"></headlink1>
		<div class="container1 ui-flex ui-flex-pack-center">
			<div v-if="eqType =='3' || eqType =='6' " class="left-container ui-border-l" style="background-color: #3FB5FF;">
				<div class="head-top">
					<img src="/static/img/icon13.png" class="pointer" v-on:click="refurbish()" />
					<div id="eqhengding" class="title">{{eqName}}</div>
					<p class="subtitle">{{eqObject.eqState==0?'离线':'在线'}}</p>
				</div>
				<div class="ui-flex ui-flex-pack-center mass-center" style="height: auto;">
					<div>

						<img v-if="btnFlag == false" v-show="clickFlag == true" id="button1" v-on:mousedown="changeimg('2')" v-on:mouseup="changeimg('1')" src="/static/img/anniu_4_l_a.png" class="pointer" width="300px" />
						<img v-if="btnFlag == false" v-show="clickFlag == false" id="button2" v-on:mousedown="changeimg('2')" v-on:mouseup="changeimg('1')" src="/static/img/anniu_4_h_a.png" class="pointer" width="300px" />
						<img v-if="btnFlag == true" id="button2" v-on:mousedown="clickimg('2')" v-on:mouseup="clickimg('1')" src="/static/img/anniu_4_h_a.png" class="pointer" width="300px" />
					</div>
				</div>
				<div class="mass-center">
					<div class="ui-form-item ui-form-item-switch">
						<label class="ui-switch" style="right: 300px;">
			                <input v-model="btnFlag" type="checkbox">
			            </label>
					</div>
					<p class="align-p" v-if="btnFlag==false">自锁模式</p>
					<p class="align-p" v-if="btnFlag==true">点动模式</p>
				</div>
				<div class="mass-center">
					<div class="mass-title">{{list1[0].citDdTime}}秒</div>
					<div class="mass-img pointer" v-if="btnFlag==false"> <img src="/static/img/shezhi_2_h.png" /> </div>
					<div class="mass-img pointer" v-on:click="showOneTime()" v-if="btnFlag==true"> <img src="/static/img/shezhi_2_b.png" /> </div>
				</div>

			</div>
			<div class="left-container ui-border-l" v-if="eqType !='3' && eqType !='6'">
				<div class="head-top">
					<img class="pointer" v-on:click="refurbish()" src="/static/img/icon13.png" />
					<div class="title">{{eqName}} </div>
					<p class="subtitle">{{eqObject.eqState==0?'离线':'在线'}}</p>
				</div>
				<div class="ui-flex ui-flex-pack-center mass-center" v-if="eqType !='7' && eqType !='4' && eqType !='12'">
					<div v-on:mousedown="open(2)" v-on:mouseup="open(1)">
						<img id="quankai" src="/static/img/qktanqi.png" class="pointer" />
						<center>
							<p align="center">全开</p>
						</center>
					</div>
					<div v-on:mousedown="close(2)" v-on:mouseup="close(1)" class="left-padding">
						<img id="quanguan" src="/static/img/qgtanqi.png" class="pointer" />
						<center>
							<p align="center">全关</p>
						</center>
					</div>
				</div>
				<div class="ui-flex ui-flex-pack-center mass-center" v-if="eqType =='7'">

					<img align="center" src="/static/img/zhuan.png" class="pointer" />

				</div>
				<div class="ui-flex ui-flex-pack-center mass-center" v-if="eqType =='12'">

					<img align="center" src="/static/img/shuju.png" class="pointer" />

				</div>

				<div class="ui-flex ui-flex-pack-center mass-center" v-if="eqType =='4'">
					<div v-on:mousedown="pkupdateEq(list1[0],1,2)" v-on:mouseup="pkupdateEq(list1[0],1,1)">
						<img id="peidiankai" src="/static/img/qktanqi.png" class="pointer" />
						<center>
							<p align="center">启动</p>
						</center>
					</div>

					<img align="center" v-bind:src="[list1[0].citLinkState==0?'/static/img/xianshihong.png':'/static/img/xianshilv.png']" />

					<div v-on:mousedown="pgupdateEq(list1[0],0,2)" v-on:mouseup="pgupdateEq(list1[0],0,1)" class="left-padding">
						<img id="peidianguan" src="/static/img/qgtanqi.png" class="pointer" />
						<center>
							<p align="center">停止</p>
						</center>
					</div>

				</div>

				<div class="mass-center-2 ui-flex ui-flex-ver ui-flex-align-start" v-if="eqType !='4'">
					<div v-for="obj in list1" style="width: 100%;">
						<div class="column1" style="position: relative;"><img v-bind:src="[obj.citLinkState==0?'/static/img/icon14.png':'/static/img/icon15.png']" style="vertical-align: middle;" />{{obj.citName}}
							<img v-on:click="showName(obj)" src="/static/img/set.png" />
							<!--<div style="position: absolute;top: 5px;left: 130px;" v-on:click="showName(obj)" class="pointer"><img src="/static/img/set.png" /> </div>-->
						</div>
						<div class="column2 ui-border-b">
							<!--有改动，把updateEq(obj,2,1)中的2 改为1 ，原因不是点动设置-->
							<!--<button class="button-type green" v-on:click="updateEq(obj,1,1)" v-on:mousedown="onmouesdown($event)" v-on:mouseup="onmouesup($event)">开</button>
							<button class="button-type red" v-on:click="updateEq(obj,1,0)" v-on:mousedown="onmouesdown($event)" v-on:mouseup="onmouesup($event)">关</button>
							<button class="button-type" v-on:click="updateEq(obj,2,2)" v-on:mousedown="onmouesdown($event)" v-on:mouseup="onmouesup($event)">点动</button>
							-->
							<button type="button" class="btn btn-primary" v-on:click="updateEq(obj,1,1)" v-on:mousedown="onmouesdown($event)" v-on:mouseup="onmouesup($event)">开</button>
							<button type="button" class="btn btn-primary" v-on:click="updateEq(obj,1,0)" v-on:mousedown="onmouesdown($event)" v-on:mouseup="onmouesup($event)">关</button>
							<button type="button" class="btn btn-primary" v-on:click="updateEq(obj,2,2)" v-on:mousedown="onmouesdown($event)" v-on:mouseup="onmouesup($event)">点动</button>
							<span class="time">{{obj.citDdTime}}秒</span>
							<!--<button class="button-type" v-on:click="showTime(obj)" v-on:mousedown="onmouesdown($event)" v-on:mouseup="onmouesup($event)">设置</button>-->
							<button type="button" class="btn btn-primary" v-on:click="showTime(obj)" v-on:mousedown="onmouesdown($event)" v-on:mouseup="onmouesup($event)">设置</button>
						</div>
					</div>
				</div>
				<!--端口报警情况-->
				<ul class="shuru-list ui-list ui-list-function ui-border-tb">
					<li class="ui-border-t" v-for="obj in list2" v-if="eqType != 12" id="bao">
						<div class="ui-list-info" id="shishi">
							<img v-bind:src="[obj.citLinkState==0?'/static/img/icon14.png':'/static/img/icon15.png']" style="vertical-align: middle;" />
							<span class="ui-nowrap">{{obj.citName}}</span>
						</div>
					</li>
				</ul>
			</div>

			<div class="right-container bluegack" style="position: relative;">
				<div class="search" results="s">
					<input class="" id="search" @keyup="updateEqList()" />
					<i class="ui-icon-search white"></i>
				</div>
				<div style="text-align:center;color:#000000"><span v-on:click="getEqListPage(pageSize-1)">< 上一页</span><span>&nbsp&nbsp&nbsp&nbsp{{pageSize+"/"+page}}&nbsp&nbsp&nbsp&nbsp</span><span v-on:click="getEqListPage(pageSize+1)">下一页 ></span>
					<ul class="shuru-list-right ui-list ui-list-function">

						<li @contextmenu.prevent="showMenu(eq,$event)" v-show="eq.eqType == 1 || eq.eqType == 2 || eq.eqType == 3 || eq.eqType == 4 || eq.eqType == 5 || eq.eqType == 6 || eq.eqType == 7 || eq.eqType == 8 || eq.eqType == 9 || eq.eqType == 10 || eq.eqType == 11 || eq.eqType == 12" v-bind:id="[eq.eqId]" class="border-bule-b pointer" v-for="(eq,index) in eqList" v-bind:class="[eq.eqId==eqId?'list-active':'']" v-on:click="clickEq(eq)">
							<div class="ui-row-flex">
								<div class="ui-col tc">
									<img v-if="eq.eqType == 1" v-bind:src="[eq.eqState==0?'/static/img/icon30.png':'/static/img/icon31.png']" />
									<img v-if="eq.eqType == 2" v-bind:src="[eq.eqState==0?'/static/img/icon17.png':'/static/img/icon16.png']" />
									<img v-if="eq.eqType == 3" v-bind:src="[eq.eqState==0?'/static/img/icon40.png':'/static/img/icon41.png']" />
									<img v-if="eq.eqType == 4" v-bind:src="[eq.eqState==0?'/static/img/peidiangui_hong.png':'/static/img/peidiangui_lv.png']" />
									<img v-if="eq.eqType == 5" v-bind:src="[eq.eqState==0?'/static/img/dingwei_hong.png':'/static/img/dingwei_lv.png']" />
									<img v-if="eq.eqType == 6" v-bind:src="[eq.eqState==0?'/static/img/danludingweihong.png':'/static/img/danludingweilv.png']" />
									<img v-if="eq.eqType == 7" v-bind:src="[eq.eqState==0?'/static/img/zhenfanzhuanhong.png':'/static/img/zhenfanzhuanlv.png']" />
									<img v-if="eq.eqType == 8" v-bind:src="[eq.eqState==0?'/static/img/baludingshilv.png':'/static/img/baludingshihong.png']" />
									<img v-if="eq.eqType == 9" v-bind:src="[eq.eqState==0?'/static/img/erludingshihong.png':'/static/img/erludingshilv.png']" />
									<img v-if="eq.eqType == 10" v-bind:src="[eq.eqState==0?'/static/img/siludingshihong.png':'/static/img/siludingshilv.png']" />
									<img v-if="eq.eqType == 11" v-bind:src="[eq.eqState==0?'/static/img/siludingweihong.png':'/static/img/siludingweilv.png']" />
									
								</div>
								<div class="ui-col ui-col-2 ui-row-flex ui-row-flex-ver">
									<div class="ui-col text1">{{eq.eqName}}</div>
									<div v-if="eq.eqDdjy==0" class="ui-col text2"><img style="vertical-align: middle;" src="/static/img/icon20.png" /> 断电不带记忆</div>
									<div v-if="eq.eqDdjy==1" class="ui-col text2"><img style="vertical-align: middle;" src="/static/img/icon21.png" /> 断电带记忆</div>
									<div class="ui-col text2">ID:{{eq.eqId}}</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			<div class="alert1 right-click" v-show="alert5">
					<div class="dialog right-click-dialog" style="margin:0px;width:200px;padding:15px 15px; background: gainsboro;">
						<ul>
							<li v-on:click="showEq()" id="xgsbmc">修改设备名称</li>
							<li v-on:click="removeEq()" id="deleq_">删除此设备</li>
							<li v-on:click="showEqDdjy()" id="ddjy">掉电记忆设置</li>
							<li v-on:click="jiaozhengshijian()" v-if="leftEq.eqType ==8 || leftEq.eqType ==9 || leftEq.eqType ==10">矫正时间</li>
							<li v-on:click="ht()" v-if="leftEq.eqType ==12">数据设备测试</li>

							<router-link :to="{ name:'ditu', params: {eqId:leftEq.eqId } }">
								<li v-if="leftEq.eqType ==5 || leftEq.eqType ==6 || leftEq.eqType ==11">显示位置</li>
							</router-link>
							<!--<router-link :to="{ name:'shuju', params: {eqId:leftEq.eqId } }">
								<li v-if="leftEq.eqType ==12 ">数据设备</li>
							</router-link>-->

							<router-link :to="{ name:'dingshi', params: {eqId:leftEq.eqId,eqType:leftEq.eqType} }">
								<li v-if="leftEq.eqType ==8 || leftEq.eqType ==9 || leftEq.eqType ==10">定时设置</li>
							</router-link>
							<router-link :to="{ name:'port', params: {eqId:leftEq.eqId,eqType:leftEq.eqType } }">
								<li id="port_" v-if="leftEq.eqType !=3 || leftEq.eqType !=6">端口报警提示设置</li>
							</router-link>
							<router-link :to="{ name:'port1', params: {eqId:leftEq.eqId } }">
								<li id="tdld">停电来电报警设置</li>
							</router-link>
							<!--<router-link :to="{ name:'baojing', params: {eqId:leftEq.eqId } }">
								<li>报警记录导出</li>
							</router-link>-->
						</ul>
					</div>
				</div>

			</div>

		</div>

		<div class="alert" v-show="alert1">
			<div class="dialog">
				<div><input class="input-type" v-model="citName" placeholder="电路名称" /> </div>
				<div style="padding: 20px;padding-bottom: 0; text-align: center;"><button class="btn-type" v-on:click="setName()">确定</button><button class="btn-type btn-close" v-on:click="closeShow(1)">取消</button></div>
			</div>
		</div>
		<div class="alert" v-show="alert6">
			<div class="dialog">
				<div><input class="input-type" v-model="alertEqName" placeholder="设备名称" /> </div>
				<div style="padding: 20px;padding-bottom: 0; text-align: center;"><button class="btn-type" v-on:click="setEqName()">确定</button><button class="btn-type btn-close" v-on:click="closeShow(6)">取消</button></div>
			</div>
		</div>
		<div class="alert" v-show="alert2">
			<div class="dialog" style="padding: 0;">
				<div class="ui-form ">
					<div class="ui-form-item ui-form-item-switch">
						<div style="color: #F9A81B; text-align: center;">
							断电记忆
						</div>
						<!--<label class="ui-switch">
			                <input type="checkbox" v-model="eqDdjy" >
			            </label>-->

					</div>
					<div class="ui-form-item ui-border-t" style="text-align: center;">

						<div style="float: left;width: 33%;color: #3FB5FF;border-right:1px solid #e0e0e0;" class="pointer" v-on:click="setEqDdjy(1)">记忆</div>
						<div style="float: left;width: 34%;color: #3FB5FF;border-right:1px solid #e0e0e0;" class="pointer" v-on:click="setEqDdjy(0)">不记忆</div>
						<div style="float: right;width: 33%;color: #3FB5FF;" class="btn-close pointer" v-on:click="closeShow(2)">取消</div>
					</div>
				</div>
			</div>
		</div>
		<!--<div class="alert" v-show="alert3" >
    	<div class="dialog" >
    		<div style="text-align:center;color:red;" >{{msg}} </div>
    	</div>
	</div>-->
		<div class="alert" v-show="alert4">
			<div class="dialog">
				<div><input id="citDdTime" v-model="citDdTime" class="input-type" placeholder="点动时间" /> </div>
				<div style="padding: 20px;padding-bottom: 0; text-align: center;"><button class="btn-type" v-on:click="setTime()">确定</button><button class="btn-type btn-close" v-on:click="closeShow(4)">取消</button></div>
			</div>
		</div>
		<div class="alert" v-show="alert7">
			<div class="dialog">
				<div><input id="citDdTime" v-model="citDdTime1" class="input-type" placeholder="点动时间" /> </div>
				<div style="padding: 20px;padding-bottom: 0; text-align: center;"><button class="btn-type pointer" v-on:click="setOneTime()">确定</button><button class="btn-type btn-close" v-on:click="closeShow(7)">取消</button></div>
			</div>
		</div>
		<audio id="audio1" src="static/audio/jingbao.mp3"></audio>

	</div>

</template>
<script>
	import headlink from '@/components/common/headlink'
	import headlink1 from '@/components/common/headlink1'
	import devicemanage1 from '@/components/devicemanage/devicemanage1'
	import devicemanage2 from '@/components/devicemanage/devicemanage2'
	var USER_ID; //websocket用户标示
	var hearttime = null; //心跳定时
	var ws_type = {
		LOGON: "logon",
		LOGOUT: "logout",
		HEARTBEAT: "heartbeat",
		WARNING: "warning",
		DATAWARN: "dataWarning",
		SIGLEDATA: "sigleData",
		MOREDATA: "moreData",
		OPENCLOSE: "openClose"
	};

	export default {
		name: 'devicemanage',
		data() {
			return {

				eqList: [],
				pageSize: 1,
				page: "",
				pagenum: 6,
				totoCount: 0,
				eqId: "",
				eqType: "",
				eqName: "",
				eqObject: {},
				list1: [],
				list2: [],

				alert1: false,
				alert2: false,
				alert3: false,
				alert4: false,
				alert5: false,
				alert6: false,
				alert7: false,
				msg: "",
				citObj: {},
				citDdTime: "",
				citName: "",
				leftEq: {},
				alertEqName: "",
				eqDdjy: false,
				parent: "0",

				clickFlag: true,
				btnFlag: false,
				citDdTime1: "",
				btnstate: false,
			}
		},

		methods: {

			//	实时报警提示
			/**
			 * 初始化WebSocket
			 */
			initWebsocketa: function() {

				var socketURL = "ws://" + "localhost:8080/ZYun" + "/websocket";
				var socket;
				socket = new WebSocket(socketURL);
				console.log(socket);

				socket.onopen = function() {

					var params = {
						type: ws_type.LOGON,
						user: USER_ID
					};
					if(socket) {
						var message = JSON.stringify(params);
						console.log("send websocket message: " + message)
						socket.send(message);
					} else {
						console.log("websocket is closed!");
					}

					//    this.$options.methods.logon();
				};

				socket.onmessage = (evt) => {
					// 收到消息回调
					//	this.$options.methods.messageCallback(evt.data);
					//		          messageCallback(evt.data);

					if(evt.data != "X") {

						var json = JSON.parse(evt.data);
						var code = json["code"];
						var type = json["type"];
						var eqname = json["eqname"];
						var eqid = json["eqid"];
						var context = json["context"];
						if(code == "0") {

							if(type == ws_type.WARNING) {
								var eqname = json["eqname"];
								var context = json["context"];
								var msgtype = json["msgtype"];
								if(msgtype == "1") {
									if(store.get("td") == true || store.get("td") == undefined) {
										Lobibox.notify('warning', {
											delay: false,
											title: 'Warning',
											msg: eqname + " : " + context
										})
										var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
									}
									this.re();
								} else if(msgtype == "2") {
									if(store.get("ld") == true || store.get("ld") == undefined) {
										Lobibox.notify('warning', {
											delay: false,
											title: 'Warning',
											msg: eqname + " : " + context
										})
										var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
									}
									this.re();
								} else if(msgtype == "3") {
if(store.get("dk")==true||store.get("dk")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
					var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								} else if(msgtype == "4") {
if(store.get("lt")==true||store.get("lt")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
					var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
										

}
									this.re();
								}

							}
  

						}
					}

				};

				socket.onclose = function(event) {
					console.log("WS is closed. " + event);
					socket = undefined;
					this.$options.methods.initWebsocket();
				};

				socket.onerror = function(event) {
					console.log("WS is error. " + event.data);
					socket = undefined;
				};
			},

			initWebsocketc: function() {

				var socketURL = "ws://" + "59.110.1.147:8080/ZYun" + "/websocket";
				var socket;
				socket = new WebSocket(socketURL);
				console.log(socket);

				socket.onopen = function() {

					var params = {
						type: ws_type.LOGON,
						user: USER_ID
					};
					if(socket) {
						var message = JSON.stringify(params);
						console.log("send websocket message: " + message)
						socket.send(message);
					} else {
						console.log("websocket is closed!");
					}

				};

				socket.onmessage = (evt) => {

					if(evt.data != "X") {

						var json = JSON.parse(evt.data);
						var code = json["code"];
						var eqname = json["eqname"];
						var eqid = json["eqid"];
						var context = json["context"];
						if(code == "0") {
							var type = json["type"];

							if(type == ws_type.WARNING) {
								var eqname = json["eqname"];
								var context = json["context"];
								var msgtype = json["msgtype"];
								if(msgtype == "1") {
if(store.get("td")==true||store.get("td")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
									var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								} else if(msgtype == "2") {
if(store.get("ld")==true||store.get("ld")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
									var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								} else if(msgtype == "3") {
if(store.get("dk")==true||store.get("dk")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
									var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								} else if(msgtype == "4") {
if(store.get("lt")==true||store.get("lt")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
									var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								}
              
							}
                     
						}
					}

				};

				socket.onclose = function(event) {
					console.log("WS is closed. " + event);
					socket = undefined;
					this.$options.methods.initWebsocket();
				};

				socket.onerror = function(event) {
					console.log("WS is error. " + event.data);
					socket = undefined;
				};
			},
			initWebsocketd: function() {

				var socketURL = "ws://" + "59.110.20.7:8080/ZYun" + "/websocket";
				var socket;
				socket = new WebSocket(socketURL);
				console.log(socket);

				socket.onopen = function() {

					var params = {
						type: ws_type.LOGON,
						user: USER_ID
					};
					if(socket) {
						var message = JSON.stringify(params);
						console.log("send websocket message: " + message)
						socket.send(message);
					} else {
						console.log("websocket is closed!");
					}

				};

				socket.onmessage = (evt) => {

					if(evt.data != "X") {

						var json = JSON.parse(evt.data);
						var code = json["code"];
						var eqname = json["eqname"];
						var eqid = json["eqid"];
						var context = json["context"];
						if(code == "0") {
							var type = json["type"];

							if(type == ws_type.WARNING) {
								var eqname = json["eqname"];
								var context = json["context"];
								var msgtype = json["msgtype"];
								if(msgtype == "1") {
if(store.get("td")==true||store.get("td")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
									var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								} else if(msgtype == "2") {
      if(store.get("ld")==true||store.get("ld")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
									var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								} else if(msgtype == "3") {
       if(store.get("dk")==true||store.get("dk")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
									var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								} else if(msgtype == "4") {
if(store.get("lt")==true||store.get("lt")==undefined) {
									Lobibox.notify('warning', {
										delay: false,
										title: 'Warning',
										msg: eqname + " : " + context
									})
									var audio = document.getElementById("audio1");
				    	audio.loop = true;
					 audio.play();
								}
									this.re();
								}
              
							}

							
							  
						}
					}

				};

				socket.onclose = function(event) {
					console.log("WS is closed. " + event);
					socket = undefined;
					this.$options.methods.initWebsocket();
				};

				socket.onerror = function(event) {
					console.log("WS is error. " + event.data);
					socket = undefined;
				};
			},
			getEqListPage: function(pageSize) {

				if(pageSize < 1) {
					pageSize = 1;
				}
				//最大页数

				if(pageSize > this.page) {
					pageSize = 1;
				}
				this.pageSize = pageSize;
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1012",
						"uId": uid,
						//当前页
						pageSize: pageSize,
						//当前页设备数
						pageNum: 6

					})
					.then((response) => {
						if(response.data.respCode == "0000") {

							this.eqList = response.data.eqList;

						} else {
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					})

			},

			onmouesup: function(event) {
				$(event.currentTarget).removeClass("gray")
				console.log("鼠标起来")
			},
			onmouesdown: function(event) {
				$(event.currentTarget).addClass("gray")
				console.log("鼠标下来")
			},
			setOneTime: function() {
				var self = this;
				this.alert7 = false;
				var re = /^[1-9]+[0-9]*]*$/;
				if(!re.test(this.citDdTime1)) {
					this.alert4 = false;
					jeBox.msg('请输入数字！', {
						icon: 3,
						time: 3
					});
					//			self.msg = "请输入数字";
					self.alert3 = true;
					window.setTimeout(function() {
						self.alert3 = false;
					}, 1000);　　　　
					return;　　
				}
				this.list1[0].citDdTime = this.citDdTime1;
				this.citDdTime1 = "";

			},
			showOneTime: function() {
				this.alert7 = true;
			},
			clickimg: function(type) {
				if(type == "1") {
					$("#button2").attr("src", "/static/img/anniu_4_h_a.png");
					var self = this;
					const history = window.sessionStorage;
					var uid = history.getItem("user");
					var data = {};
					var value = "2";

					data = {
						"serviceCode": "1019",
						"uId": uid,
						eqId: this.eqId,
						citId: this.list1[0].citId,
						citState: value,
						citDdTime: this.list1[0].citDdTime
					}
					this.$http.post('/ZYun/HttpService.do', data)
						.then((response) => {
							if(response.data.respCode == "0000") {
								jeBox.msg('操作成功！', {
									icon: 2,
									time: 1
								});

								self.msg = "操作成功";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
								}, 1000);

								//								this.clickEq(this.eqObject);
							} else {
								jeBox.msg('操作失败！', {
									icon: 3,
									time: 1
								});

								self.msg = "操作失败";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
								}, 1000);
								console.log(response);
							}
						})
						.catch((response) => {
							console.log(response);
						});
				} else {
					$("#button2").attr("src", "/static/img/anniu_4_h_b.png");
				}
			},
			changeimg: function(type) {
				if(this.clickFlag == true) {
					if(type == "1") {
						$("#button1").attr("src", "/static/img/anniu_4_l_a.png");
						var self = this;
						const history = window.sessionStorage;
						var uid = history.getItem("user");
						var data = {};
						var value = "0";
						if(this.clickFlag == false) {
							value = "1";
						}
						data = {
							"serviceCode": "1019",
							"uId": uid,
							eqId: this.eqId,
							citId: this.list1[0].citId,
							citState: value
						}

						this.$http.post('/ZYun/HttpService.do', data)
							.then((response) => {
								if(response.data.respCode == "0000") {

									jeBox.msg('操作成功！', {
										icon: 2,
										time: 1
									});
									self.msg = "操作成功";
									self.alert3 = true;
									window.setTimeout(function() {
										self.alert3 = false;
									}, 1000);
									window.setTimeout(function() {
										if(self.clickFlag == false) {
											self.clickFlag = true;
										} else {
											self.clickFlag = false;
										}
									}, 100)
									//	this.clickEq(this.eqObject);
								} else {
									jeBox.msg('操作失败！', {
										icon: 3,
										time: 1
									});
									self.msg = "操作失败";
									self.alert3 = true;
									window.setTimeout(function() {
										self.alert3 = false;
									}, 1000);
									console.log(response);
								}
							})
							.catch((response) => {
								console.log(response);
							});

					} else {
						$("#button1").attr("src", "/static/img/anniu_4_l_b.png");
					}
				}
				if(this.clickFlag == false) {
					if(type == "1") {
						$("#button2").attr("src", "/static/img/anniu_4_h_a.png");
						var self = this;
						const history = window.sessionStorage;
						var uid = history.getItem("user");
						var data = {};
						var value = "0";
						if(this.clickFlag == false) {
							value = "1";
						}
						data = {
							"serviceCode": "1019",
							"uId": uid,
							eqId: this.eqId,
							citId: this.list1[0].citId,
							citState: value
						}

						this.$http.post('/ZYun/HttpService.do', data)
							.then((response) => {
								if(response.data.respCode == "0000") {
									jeBox.msg('操作成功！', {
										icon: 2,
										time: 1
									});
									self.msg = "操作成功";
									self.alert3 = true;
									window.setTimeout(function() {
										self.alert3 = false;
									}, 1000);
									window.setTimeout(function() {
										if(self.clickFlag == false) {
											self.clickFlag = true;
										} else {
											self.clickFlag = false;
										}
									}, 100)
									//	this.clickEq(this.eqObject);
								} else {
									jeBox.msg('操作失败！', {
										icon: 3,
										time: 1
									});
									self.msg = "操作失败";
									self.alert3 = true;
									window.setTimeout(function() {
										self.alert3 = false;
									}, 1000);
									console.log(response);
								}
							})
							.catch((response) => {
								console.log(response);
							});
					} else {
						$("#button2").attr("src", "/static/img/anniu_4_h_b.png");
					}
				}

			},
			setEqDdjy: function(jiyi) {

				this.alert2 = false;
				var self = this;
				const history = window.sessionStorage;
				var uid = history.getItem("user");

				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1017",
						"uId": uid,
						eqId: this.leftEq.eqId,
						ddjyFlag: jiyi
					})
					.then((response) => {
						if(response.data.respCode == "0000") {
							jeBox.msg('操作成功！', {
								icon: 2,
								time: 1
							});
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
							this.$http.post('/ZYun/HttpService.do', {
									"serviceCode": "1012",
									"uId": uid
								})
								.then((response) => {
									if(response.data.respCode == "0000") {
										this.eqList = response.data.eqList;
										this.eqId = this.eqList[0].eqId;
										this.clickEq(this.eqList[0]);
									} else {
										console.log(response);
									}
								})
								.catch((response) => {
									//									console.log(response);
								});
						} else {
							jeBox.msg('操作失败！', {
								icon: 3,
								time: 1
							});
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					});
			},
			showEqDdjy: function() {
				this.alert5 = false;
				this.alert2 = true;
				//				if(this.leftEq.eqDdjy == "0") {
				//					this.eqDdjy = "0";
				//				}
				//				if(this.leftEq.eqDdjy == "1") {
				//					this.eqDdjy = "1";
				//				}
			},
			ipshow: function() {

				window.location = "ip.html";

			},
			ht: function() {

				window.location = "new_file.html";

			},

			jiaozhengshijian: function() {

				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1026",
						"uId": uid,
						eqId: this.leftEq.eqId
					})
					.then((response) => {
						if(response.data.respCode == "0000") {
							jeBox.msg('操作成功！', {
								icon: 2,
								time: 1
							});
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
						} else {
							jeBox.msg('操作失败！', {
								icon: 3,
								time: 1
							});
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					});

			},

			setEqName: function() {
				this.alert6 = false;
				var self = this;
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1017",
						"uId": uid,
						eqId: this.leftEq.eqId,
						eqName: this.alertEqName
					})
					.then((response) => {
						if(response.data.respCode == "0000") {
							jeBox.msg('操作成功！', {
								icon: 2,
								time: 1
							});
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
							this.$http.post('/ZYun/HttpService.do', {
									"serviceCode": "1012",
									"uId": uid
								})
								.then((response) => {
									if(response.data.respCode == "0000") {
										this.eqList = response.data.eqList;
										this.eqId = this.eqList[0].eqId;
										this.clickEq(this.eqList[0]);
									} else {
										console.log(response);
									}
								})
								.catch((response) => {
									console.log(response);
								});
						} else {
							jeBox.msg('操作失败！', {
								icon: 3,
								time: 1
							});
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					});
			},
			showEq: function() {
				this.alertEqName = "";
				this.alert6 = true;
				this.alert5 = false;
			},
			removeEq: function() {
				this.alert5 = false;
				var self = this;
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1010",
						"uId": uid,
						eqId: this.leftEq.eqId
					})
					.then((response) => {
						if(response.data.respCode == "0000") {
							jeBox.msg('操作成功！', {
								icon: 2,
								time: 1
							});
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
						} else {
							jeBox.msg('操作失败！', {
								icon: 3,
								time: 1
							});
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					});
			},
			closeMenu: function() {
				this.alert5 = false;
			},
			showMenu: function(obj, event) {
				this.leftEq = obj;
				this.alert5 = true;
				this.$store.state.alert5 = true;
				console.log(event)
				console.log(event.pageY)
				console.log(event.pageX)
				$(".right-click").css({
					top: event.pageY - 130,
					left: event.pageX - 1000
				})

			},
			setName: function() {
				this.alert1 = false;
				this.rename(this.citObj, 1, this.citName);
				this.citName = "";
			},
			showName: function(obj) {
				this.citObj = obj;
				this.alert1 = true;
			},
			//数据库查询设备最新状态
			re: function() {
				
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				    pwdmd5=store.get("pwd");
				$("#eqhengding").text(this.eqName);
				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1018",
						"uId": uid,
						"eqId": this.eqId,
						"userPwd": pwdmd5
						 
					})
					.then((response) => {
						console.log(response+"+++++++++++++++++++++++++++++++++++++++++");
						if(response.data.respCode == "0000") {
							this.eqObject = response.data;
							this.eqType = response.data.eqType;
							this.list1 = [];
							this.list2 = [];
							for(var cit of this.eqObject.citList) {
								var word1 = cit.citType.substring(0, 1);
								var word2 = cit.citType.substring(1, 2);
								var i = parseInt(word2) - 1;
								if(word1 == "0") {
									this.list1[i] = cit;
								} else {
									//端口的集合
									this.list2[i] = cit;

								}
							}
							var b = this.list1[0].citLinkState == "1";
							this.clickFlag = b;
							this.citDdTime1 = this.list2[0].citDdTime;

						} else {
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					});

			},
			//读取设备最新状态
			refurbish: function() {
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1021",
						"uId": uid,
						eqId: this.eqId
					})
					.then((response) => {
						if(response.data.respCode == "0000") {
							this.eqObject = response.data;
							this.eqType = response.data.eqType;
							this.list1 = [];
							this.list2 = [];
							for(var cit of this.eqObject.citList) {
								var word1 = cit.citType.substring(0, 1);
								var word2 = cit.citType.substring(1, 2);
								var i = parseInt(word2) - 1;
								if(word1 == "0") {
									this.list1[i] = cit;
								} else {
									this.list2[i] = cit;
								}
							}
						} else {
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					});
			},
			closeShow(obj) {
				if(obj == "1") {
					this.alert1 = false;
				}
				if(obj == "2") {
					this.alert2 = false;
				}
				if(obj == "3") {
					this.alert3 = false;
				}
				if(obj == "4") {
					this.alert4 = false;
				}
				if(obj == "5") {
					this.alert5 = false;
				}
				if(obj == "6") {
					this.alert6 = false;
				}
				if(obj == "7") {
					this.alert7 = false;
				}
			},
			setTime: function() {
				var self = this;
				var re = /^[1-9]+[0-9]*]*$/;
				if(!re.test(this.citDdTime)) {
					this.alert4 = false;
					jeBox.msg('请输入数字！', {
						icon: 3,
						time: 3
					});
					//				self.msg = "请输入数字";
					self.alert3 = true;
					window.setTimeout(function() {
						self.alert3 = false;
					}, 1000);　　　　
					return;　　
				}
				this.citObj.citDdTime = this.citDdTime;
				this.alert4 = false;
			},
			showTime: function(obj) {
				this.citDdTime = "";
				this.alert4 = true;
				this.citObj = obj;
			},
			pad: function(num, n) {
				var len = num.toString().length;
				while(len < n) {
					num = "0" + num;
					len++;
				}
				return num;
			},
			clickEq(eq) {
				console.log("into")
				$("#" + eq.eqId).addClass("list-active");
				this.eqObject = eq;
				this.eqId = eq.eqId;
				this.eqName = eq.eqName;
                const history = window.sessionStorage;
				var uid = history.getItem("user");
				var eqId = history.setItem("eqId", this.eqId);
                 
				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1018",
						"uId": uid,
						"eqId": this.eqId
						
					})
					.then((response) => {
						console.log(response+"+++++++++++++++++++++++++++++++++++++++++++++++++++++");
						if(response.data.respCode == "0000") {
							this.eqObject = response.data;
							this.eqType = response.data.eqType;
							const history = window.sessionStorage;
							var eqType = history.setItem("eqType", this.eqType);
							this.list1 = [];
							this.list2 = [];
							for(var cit of this.eqObject.citList) {
								//						如果word1是0，就是电路 否则就是端口
								var word1 = cit.citType.substring(0, 1);
								var word2 = cit.citType.substring(1, 2);
								var i = parseInt(word2) - 1;
								if(word1 == "0") {
									this.list1[i] = cit;
								} else {
									this.list2[i] = cit;

								}
							}
							var b = this.list1[0].citLinkState == "1";
							this.clickFlag = b;
							this.citDdTime1 = this.list2[0].citDdTime;

						} else {
							console.log(response);
						}

					})
					.catch((response) => {
						console.log(response);
					});
			},

			open: function(t) {
				
				if(t == "1") {
					
					$("#quankai").attr("src", "/static/img/qktanqi.png")
					var self = this;
					
					this.eqObject.eqName = this.eqName;
					const history = window.sessionStorage;
					var uid = history.getItem("user");
					this.$http.post('/ZYun/HttpService.do', {
							"serviceCode": "1020",
							"uId": uid,
							eqId: this.eqId,
							citState: "1"
						})
						.then((response) => {
							if(response.data.respCode == "0000") {
								
								jeBox.msg('操作成功！', {
									icon: 2,
									time: 1
								});
								self.msg = "设备全开成功";
								self.alert3 = true;
								
								window.setTimeout(function() {
									self.alert3 = false;
									self.clickEq(self.eqObject);
								}, 2000);
					
                           } else {
								jeBox.msg('操作失败！', {
									icon: 3,
									time: 1
								});
								self.msg = "设备全开失败";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
									self.clickEq(self.eqObject);
								}, 2000);
								console.log(response);
								
							}
                        
						 
						})
						.catch((response) => {
							console.log(response);
						})
						
				} else $("#quankai").attr("src", "/static/img/quankailv.png")
				
			},
			close: function(t) {
				if(t == "1") {
					$("#quanguan").attr("src", "/static/img/qgtanqi.png")

					var self = this;
					
					this.eqObject.eqName = this.eqName;
					const history = window.sessionStorage;
					var uid = history.getItem("user");
					this.$http.post('/ZYun/HttpService.do', {
							"serviceCode": "1020",
							"uId": uid,
							eqId: this.eqId,
							citState: "0"
						})
						.then((response) => {
							if(response.data.respCode == "0000") {
								jeBox.msg('操作成功！', {
									icon: 2,
									time: 1
								});
								self.msg = "设备全关成功";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
								self.clickEq(self.eqObject);
								}, 2000);
								
							} else {
								jeBox.msg('操作失败！', {
									icon: 3,
									time: 1
								});
								self.msg = "设备全关失败";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
									self.clickEq(self.eqObject);
								}, 2000);
							
							}
							
						})
						.catch((response) => {
							console.log(response);
						})
						
				} else $("#quanguan").attr("src", "/static/img/quankaihong.png")
				$("#eqhengding").text(this.eqName)
			},

			pkupdateEq: function(obj, value, xg) {

				if(xg == "1" && value == "1") {
					$("#peidiankai").attr("src", "/static/img/qktanqi.png")
					var self = this;
					const history = window.sessionStorage;
					var uid = history.getItem("user");
					
					this.eqObject.eqName = this.eqName;
					var data = {};
					data = {
						"serviceCode": "1019",
						"uId": uid,
						eqId: this.eqId,
						citId: obj.citId,
						citState: value
					}

					this.$http.post('/ZYun/HttpService.do', data)
						.then((response) => {
							if(response.data.respCode == "0000") {
								jeBox.msg('操作成功！', {
									icon: 2,
									time: 1
								});
								self.msg = "操作成功";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
									self.clickEq(self.eqObject);
								}, 2000);
								
							} else {
								jeBox.msg('操作失败！', {
									icon: 3,
									time: 1
								});
								self.msg = "操作失败";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
								}, 2000);
								self.clickEq(self.eqObject);
								console.log(response);
							}
							
							
						})
						.catch((response) => {
							console.log(response);
						})
					
				} else if(xg == "2" && value == "1") {
					$("#peidiankai").attr("src", "/static/img/quankailv.png")
				}

			},
			//012
			//002
			pgupdateEq: function(obj, value, xg) {
				if(xg == "1" && value == "0") {
					$("#peidianguan").attr("src", "/static/img/qgtanqi.png")
					var self = this;
					const history = window.sessionStorage;
					var uid = history.getItem("user");
					
					this.eqObject.eqName = this.eqName;
					var data = {};
					data = {
						"serviceCode": "1019",
						"uId": uid,
						eqId: this.eqId,
						citId: obj.citId,
						citState: value
					}

					this.$http.post('/ZYun/HttpService.do', data)
						.then((response) => {
							if(response.data.respCode == "0000") {
								jeBox.msg('操作成功！', {
									icon: 2,
									time: 1
								});
								self.msg = "操作成功";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
									self.clickEq(self.eqObject);
								}, 2000);
								
							} else {
								jeBox.msg('操作失败！', {
									icon: 3,
									time: 1
								});
								self.msg = "操作失败";
								self.alert3 = true;
								window.setTimeout(function() {
									self.alert3 = false;
									self.clickEq(self.eqObject);
								}, 2000);
								console.log(response);
							}
							
						})
						.catch((response) => {
							console.log(response);
						})
				} else if(xg == "2" && value == "0") {
					$("#peidianguan").attr("src", "/static/img/quankaihong.png")
				}
				
			},
			updateEq: function(obj, type, value) {
				var self = this;
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				
				this.eqObject.eqName = this.eqName;
				var data = {};
				if(type == 1) {
					data = {
						"serviceCode": "1019",
						"uId": uid,
						eqId: this.eqId,
						citId: obj.citId,
						//有改动
						citState: value
					}
				}
				console.log(obj.citDdTime)
				if(type == 2) {
					data = {
						"serviceCode": "1019",
						"uId": uid,
						eqId: this.eqId,
						citId: obj.citId,
						citState: value,
						citDdTime: obj.citDdTime
					}
				}
				this.$http.post('/ZYun/HttpService.do', data)
					.then((response) => {
						if(response.data.respCode == "0000") {
							jeBox.msg('操作成功！', {
								icon: 2,
								time: 1
							});
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
								self.clickEq(self.eqObject);
							}, 2000);
							
						} else {
							jeBox.msg('操作失败！', {
								icon: 3,
								time: 1
							});
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
								self.clickEq(self.eqObject);
							}, 2000);
							console.log(response);
						}
						
					})
					.catch((response) => {
						console.log(response);
					});
						
			},

			rename: function(obj, type, value) {
				var self = this;
				const history = window.sessionStorage;
				var uid = history.getItem("user");
				this.eqObject.eqName = this.eqName;
				var data = {
					"serviceCode": "1019",
					"uId": uid,
					eqId: this.eqId,
					citId: obj.citId,
					citName: value
				}
				this.$http.post('/ZYun/HttpService.do', data)
					.then((response) => {
						if(response.data.respCode == "0000") {
							jeBox.msg('操作成功！', {
								icon: 2,
								time: 1
							});
							self.msg = "操作成功";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
							this.clickEq(this.eqObject);
						} else {
							jeBox.msg('操作失败！', {
								icon: 3,
								time: 1
							});
							self.msg = "操作失败";
							self.alert3 = true;
							window.setTimeout(function() {
								self.alert3 = false;
							}, 1000);
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					});

			},

			updateEqList() {
				var keywords = $("#search").val();

				const history = window.sessionStorage;
				var uid = history.getItem("user");
				var parent = history.getItem("parent");
				this.parent = parent;
				console.log("-------------" + keywords)

				//if(""==keywords){
				//	return;
				//}
				this.$http.post('/ZYun/HttpService.do', {
						"serviceCode": "1012",
						"uId": uid,
						"condition": keywords
					})
					.then((response) => {
						if(response.data.respCode == "0000") {
							this.eqList = response.data.eqList;
							this.eqId = this.eqList[0].eqId;
							this.clickEq(this.eqList[0]);
						} else {
							console.log(response);
						}
					})
					.catch((response) => {
						console.log(response);
					});
			}
		},

		mounted: function() {
			
			
			
			var mobile = window.sessionStorage.getItem("mobile");
			var userSign = window.sessionStorage.getItem("userSign");
			USER_ID = mobile + userSign;

			this.initWebsocketa();

			this.initWebsocketc();
			this.initWebsocketd();

			//2秒执行一次re 方法
			//			this.$nextTick(function() {
			//				setInterval(this.re, 6000);
			//			})
			//      this.$nextTick(function() {
			//				setInterval(this.refurbish, 40000);
			//			 })
			const history = window.sessionStorage;
			var uid = history.getItem("user");
			var parent = history.getItem("parent");
			this.parent = parent;
		    var childid = store.get("childid");
		    var ddjysz = store.get("ddjy" + childid);
			var dkbj = store.get("dkbj" + childid);
			var tlbj = store.get("tlbj" + childid);
			var xgsbmc = store.get("xgsbmc" + childid);
			 console.log(ddjysz);
			 console.log(dkbj);
			 console.log(tlbj);
			 console.log(xgsbmc);
			 if(parent == '1'){
			 	$("#deleq_").remove();
			if (ddjysz == undefined||ddjysz == "undefined") {
				$("#ddjy").remove();
			} 
			if (dkbj == undefined||dkbj == "undefined") {
				$("#port_").remove();
			} 
			if (xgsbmc == undefined||xgsbmc == "undefined") {
				$("#xgsbmc").remove();
			} 
			if (tlbj == undefined||tlbj == "undefined") {
				$("#tdld").remove();
			} 
           }
            this.$http.post('/ZYun/HttpService.do', {
					"serviceCode": "1012",
					"uId": uid,
					//当前页
					pageSize: this.pageSize,
					//当前页设备数
					pageNum: 6

				})
				.then((response) => {
					if(response.data.respCode == "0000") {
						this.eqList = response.data.eqList;
						this.totoCount = response.data.totoCount;
						this.page = Math.floor(this.totoCount / 6) + (this.totoCount % 6 == 0 ? 0 : 1);
						this.eqId = this.eqList[0].eqId;

						this.clickEq(this.eqList[0]);
					} else {
						console.log(response);
					}
				})
				.catch((response) => {
					console.log(response);
				});
		},
		components: {
			headlink: headlink,
			headlink1: headlink1,
			devicemanage1: devicemanage1,
			devicemanage2: devicemanage2
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../../../static/css/mass.css">
	.list-active {
		background-color: #0101FE;
	}
</style>


// WEBPACK FOOTER //
// src/components/devicemanage/devicemanage.vue